
import XHeader from 'vux/src/components/x-header/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {

data(){
return {
}
},
components: {
XHeader, Icon,XButton
},
methods:{
back(){
window.history.go(-1);
},
colse(){
WeixinJSBridge.call("closeWindow");
}
},
mounted(){
}
}



// WEBPACK FOOTER //
// ./src/project/ValuationProject/serviceSubmissionResult.vue